import apiClient from "./apiClient";
import { BaseService } from "./baseService";
import { PatientSurgeryDto, patientSurgeryFormData, PatientSurgeryDropDownDto } from "../types/patientSurgery";

class PatientSurgeryService extends BaseService<PatientSurgeryDto, typeof patientSurgeryFormData> {
  constructor() {
    super("/PatientSurgery");
  }

async getDropdownByPatientId(
    patientId: number, 
    signal?: AbortSignal
  ): Promise<PatientSurgeryDropDownDto[]> {
    const response = await apiClient.get<PatientSurgeryDropDownDto[]>(`${this.url}/patient/${patientId}/dropdown`, {
      signal,
    });
    return response.data;
  }

}

export const patientSurgeryService = new PatientSurgeryService();
